// extracted by mini-css-extract-plugin
export default {"row":"WLwhZ","textNoMargin":"_36_qh","textLineHeight":"_2aBML","preWrap":"_34Ron","ellipsis":"_6laD7"};